import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/app/providers/auth-provider';
import { AppRouter } from '@/app/router';
import '@/app/styles.css';
export function App() {
    return (_jsx(BrowserRouter, { children: _jsx(AuthProvider, { children: _jsx(AppRouter, {}) }) }));
}
